import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin         : false,  //用户登录状态
  },
  getters : {
    isLogin         : state => state.isLogin,
  },
  mutations: {
    /*更新登录状态*/
    SET_LOGIN       : ( state, isLogin ) => {
      state.isLogin = isLogin === true;
    },
  },
  actions: {
    setLogin( { commit }, isLogin ){
      commit('SET_LOGIN', isLogin);
    },
  },
  modules: {
  }
})
